import { useNavigate, useParams } from 'react-router-dom'
import { useRef } from 'react'

//components
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup'

//api
import { PromptService } from '../../../../service/prompt-service'

const DeletePrompt = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const toastDelete = useRef(null)

  const confirmDelete = (event) => {
    confirmPopup({
      target: event.currentTarget,
      message: 'Sei sicuro di voler eliminare questo prompt?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      acceptClassName: 'p-button-danger',
      accept: handleDelete,
      reject: () => {
        toastDelete.current.show({
          severity: 'info',
          summary: 'Annullato',
          detail: 'Eliminazione annullata.',
          life: 3000,
        })
      },
    })
  }

  const handleDelete = () => {
    PromptService.deletePrompt(id, () => {
      toastDelete.current.show({
        severity: 'success',
        summary: 'Successo',
        detail: 'Prompt eliminato con successo!',
        life: 3000,
      })
      setTimeout(() => {
        navigate('/dashboard/prompt')
      }, 1500)
    })
  }

  return (
    <>
      <Toast ref={toastDelete} />
      <ConfirmPopup />
      <Button
        type="button"
        severity="danger"
        className="prompt__DeleteButton"
        onClick={confirmDelete}
      >
        Elimina
      </Button>
    </>
  )
}

export default DeletePrompt
